import React from 'react'
import Card from './Card'

{
  /* <ScholarshipCard
    name="Full Sail University"
    logo="images/fullsail.jpg"
    link="https://www.fullsail.edu/about/esports" /> */
}

const InquiryCard = ({ header, name, photo, title, email }) => {
  return (
    <Card key={name} className="column--fourth">
      <div className="meta centered">
        <h3 className="h3">{header}</h3>
        {/*<img src={logo} />*/}
        <div className="img" style={{ backgroundImage: `url(${photo})` }} />
        <h6>{name}</h6>
        <p>{title}</p>
        <a className="btn btn__primary" href={'mailto:' + email}>Get in touch</a>
      </div>
    </Card>
  )
}

export default InquiryCard



// WEBPACK FOOTER //
// ./src/common/ui/good_components/InquiryCard.jsx